import React from 'react';

/**
 * TaskForm - Wiederverwendbares Formular für das Erstellen und Bearbeiten von Aufgaben.
 *
 * @param {Object} props - Props der Komponente.
 * @param {Object} props.data - Formulardaten (Title, Description, ContactId, DueDate, Status).
 * @param {Function} props.onChange - Handler für Änderungen an den Formulardaten.
 * @param {Array} props.contacts - Liste der Kontakte für das Dropdown.
 * @param {Array} props.companies - Liste der Unternehmen (für die Anzeige im Kontakt-Dropdown).
 * @param {boolean} props.isEditMode - Ob das Formular im Bearbeitungsmodus ist.
 * @param {number|null} props.selectedCompanyId - Optional: Voreingestelltes Unternehmen für die Filterung der Kontakte.
 * @returns {JSX.Element} - Das gerenderte Formular.
 */
const TaskForm = ({
  data,
  onChange,
  contacts,
  companies,
  isEditMode = false,
  selectedCompanyId = null,
}) => {
  // Handler für Änderungen an Formularfeldern
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  // Filtere Kontakte nach Unternehmen, falls selectedCompanyId übergeben wurde
  const filteredContacts = selectedCompanyId
    ? contacts.filter((contact) => contact.companyId === selectedCompanyId && contact.active)
    : contacts.filter((contact) => contact.active);

  return (
    <>
      {/* Titel */}
      <div className="form-group">
        <label>Titel:*</label>
        <input
          type="text"
          value={data.Title || ''}
          onChange={(e) => handleChange('Title', e.target.value)}
          required
        />
      </div>

      {/* Beschreibung */}
      <div className="form-group">
        <label>Beschreibung:</label>
        <textarea
          value={data.Description || ''}
          onChange={(e) => handleChange('Description', e.target.value)}
        />
      </div>

      {/* Kontakt-Dropdown */}
      <div className="form-group">
        <label>Kontakt:*</label>
        <select
          value={data.ContactId || ''}
          onChange={(e) => handleChange('ContactId', e.target.value)}
          required
          className="filter-select"
          disabled={isEditMode && !selectedCompanyId} // Deaktiviert, wenn im Bearbeitungsmodus und kein Unternehmen ausgewählt
        >
          <option value="">– Wählen –</option>
          {filteredContacts.map((contact) => (
            <option key={contact.id} value={contact.id}>
              {contact.firstName} {contact.lastName} (
              {companies.find((c) => c.id === contact.companyId)?.name || 'Unbekannt'})
            </option>
          ))}
        </select>
      </div>

      {/* Fälligkeitsdatum */}
      <div className="form-group">
        <label>Fällig am:</label>
        <input
          type="date"
          value={data.DueDate ? data.DueDate.split('T')[0] : ''}
          onChange={(e) => handleChange('DueDate', e.target.value)}
        />
      </div>
    </>
  );
};

export default TaskForm;